import React from "react";
import { PaperClipOutlined } from "@ant-design/icons";

import BusinessObjectCard from "./BusinessObjectCard";

function Chip({ chip }) {
    return (
        <span className={`inbox-list-chip inbox-list-chip-${chip.tone || "neutral"}`}>
            {chip.icon === "attachment" ? <PaperClipOutlined aria-hidden="true" /> : null}
            <span>{chip.label}</span>
        </span>
    );
}

export default function ConversationListItem({ conversation, selected = false, onSelect }) {
    return (
        <button
            type="button"
            className={`inbox-conversation-item${selected ? " inbox-conversation-item-selected" : ""}`}
            aria-pressed={selected}
            onClick={onSelect}
        >
            <span className="inbox-conversation-main">
                <span className="inbox-conversation-title-row">
                    <span className="inbox-conversation-subject">{conversation.subject}</span>
                    <span className="inbox-conversation-time" title={conversation.latestTime.absoluteText}>
                        <span>{conversation.latestTime.relativeText}</span>
                        <span>{conversation.latestTime.absoluteText}</span>
                    </span>
                </span>

                <span className="inbox-conversation-sender-row">
                    <span className="inbox-conversation-sender">{conversation.sender.label}</span>
                    <span className="inbox-conversation-mailbox">{conversation.mailbox.label}</span>
                </span>

                {conversation.summary ? (
                    <span className="inbox-conversation-summary">{conversation.summary}</span>
                ) : (
                    <span className="inbox-conversation-summary inbox-conversation-summary-muted">暂无摘要</span>
                )}

                <span className="inbox-conversation-chip-row">
                    {conversation.chips.map((chip) => <Chip key={chip.key} chip={chip} />)}
                </span>

                {conversation.visibleBusinessObjects.length > 0 ? (
                    <span className="inbox-business-object-row">
                        {conversation.visibleBusinessObjects.map((item) => (
                            <BusinessObjectCard
                                key={item.key}
                                entityType={item.entityType}
                                entityId={item.entityId}
                                snapshot={item.snapshot}
                                links={item.links}
                                status={item.status}
                                compact
                            />
                        ))}
                        {conversation.businessObjectOverflowCount > 0 ? (
                            <span className="inbox-business-object-more">+{conversation.businessObjectOverflowCount}</span>
                        ) : null}
                    </span>
                ) : null}
            </span>
        </button>
    );
}
